import { render, staticRenderFns } from "./SiteDocumentNewFrProject.vue?vue&type=template&id=1790f74d"
import script from "./SiteDocumentNewFrProject.vue?vue&type=script&lang=js"
export * from "./SiteDocumentNewFrProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports